import { GiMedievalGate } from "react-icons/gi";
import { BsBuildingFill, BsHousesFill } from "react-icons/bs";
import { MdFamilyRestroom } from "react-icons/md";
import { ImHome2 } from "react-icons/im";
import { TabButtonType } from "@habity/types";

export const getCuratedButtons = (signedIn?: boolean): TabButtonType[] => {
  return [
    {
      title: "Alla",
      icon: BsHousesFill,
      key: {
        statuses: ["for_sale", "premarket"],
      },
    },
    {
      title: "Våningar",
      icon: BsBuildingFill,
      key: {
        // is_claimed: true,
        price_min: 8000000,
        statuses: ["soon_for_sale", "for_sale"],
        categories: ["apartment"],
        places: [
          "O:R:5695409",
          "O:R:5695411",
          "O:R:5695423",
          "O:R:5695402",
          "O:R:5689372",
          "O:R:5695398",
        ],
      },
    },
    {
      title: "Torp",
      icon: ImHome2,
      key: {
        price_max: 4000000,
        statuses: ["soon_for_sale", "for_sale"],
        categories: ["cottage"],
      },
    },
    // {
    //   title: 'Strandhuset',
    //   icon: FaUmbrellaBeach,
    //   key: {
    //     living_space_max: 75,
    //     categories: ['HOUSE', 'COTTAGE'],
    //     places: ['O:R:941530', 'O:R:14338641', 'O:N:30903121', 'O:N:130148772'],
    //   },
    // },
    // {
    //   title: 'Fjällstugan',
    //   icon: FaSkiing,
    //   key: {
    //     living_space_max: 95,
    //     price_max: 4000000,
    //     statuses: ['openForBid', 'forSale'],
    //     categories: [
    //       'HOUSE',
    //       'COTTAGE',
    //       'SEMI-DETACHED',
    //       'TOWNHOUSE',
    //       'OTHER',
    //       'FARM',
    //     ],
    //     places: [
    //       'O:R:F52827', // Västernorrlands län
    //       'O:R:52826', // Jämtlands län
    //       'O:R:52824', // Norrbottens län
    //       'O:R:52825', // Västerbottens län
    //       'O:R:52834', // Dalarnas län
    //     ],
    //   },
    // },
    // {
    //   title: 'Studentlyan',
    //   icon: IoMdSchool,
    //   key: {
    //     nearby: ['college'],
    //     places: [
    //       'O:N:25735371', // Uppsala
    //       'O:R:2468628', // Lund
    //       'O:N:20975578', // Linköping
    //       'O:N:25930131', // Göteborg
    //       'O:R:398021', // Stockholm
    //       'O:R:10663667', // Malmö
    //     ],
    //   },
    // },
    // {
    //   title: 'Studentlyor',
    //   icon: IoMdSchool,
    //   key: {
    //     is_claimed: true,
    //     statuses: ['openForBid', 'forSale'],
    //     nearby: ['university'],
    //     price_max: 4000000,
    //   },
    // },
    {
      title: "Familjevillor",
      icon: MdFamilyRestroom,
      key: {
        nearby: ["kindergarten"],
        rooms_min: 3,
        rooms_max: 7,
        price_max: 9000000,
        price_min: 3000000,
        statuses: ["soon_for_sale", "for_sale"],
        categories: ["house", "twinhouse", "townhouse", "terraced", "farm"],
      },
    },
    {
      title: "Lyxkåkar",
      icon: GiMedievalGate,
      key: {
        living_space_min: 300,
        price_min: 16000000,
        statuses: ["soon_for_sale", "for_sale"],
        categories: ["house", "twinhouse", "townhouse", "other", "farm"],
      },
    },
  ];
};
